import VideoGrid from '../components/grid/VideoGrid';
import Tags from '../components/tags/Tags';

export default function Home() {
  return (
    <>
      <Tags />
      <VideoGrid />
    </>
  );
}
